module.exports = __webpack_public_path__ + "img/lj.011ffa48.png";